import {ITraveller} from "@/model/Traveller"

export interface IHasTravellersSelected {
    getTravellersSelected(): ITraveller[]
    getTravellersSelectedMap(): Map<string, ITraveller>
    addTravellerSelected(traveller: ITraveller): void
    removeTravellerSelected(traveller: ITraveller): void
}

function hasTravellersSelected<TBase extends Constructor>(Base: TBase) {
    
    class Bob extends Base implements IHasTravellersSelected {
        private travellersSelected: ITraveller[] = []
        private travellersSelectedMap: Map<string, ITraveller> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }
        
        public getTravellersSelected(): ITraveller[] {
            return this.travellersSelected
        }
        public getTravellersSelectedMap(): Map<string, ITraveller> {
            return this.travellersSelectedMap
        }
        public addTravellerSelected(traveller: ITraveller): void {
            if (this.travellersSelectedMap.has(traveller.getId())) return
            this.travellersSelected.push(traveller)
            this.travellersSelectedMap.set(traveller.getId(), traveller)
        }
        public removeTravellerSelected(traveller: ITraveller): void {
            if (!this.travellersSelectedMap.has(traveller.getId())) return
            this.travellersSelected = this.travellersSelected.filter((_=>_.getId() !== traveller.getId()))
            this.travellersSelectedMap.delete(traveller.getId())
        }
    }
    return Bob
}

export default hasTravellersSelected